import dayjs from 'dayjs';

import { DEFAULT_BILL_TO_ADDRESS_ACCOUNTS_RECEIVABLE_ID } from 'contacts/constants/location';
import { ShipSelection } from 'quotes/components/CustomerQuoteUpsert/ShipSelectionDateFields/enums';
import { OrderType } from 'quotes/enums';
import { ICustomerQuote } from 'quotes/types';
import { getDefaultEarliestAcceptableDate } from 'quotes/utils';

export const getDefaultValues = (quote: ICustomerQuote, isAlternateVersionEnabled = false) => {
  if (!isAlternateVersionEnabled) {
    return {};
  }

  const billToAccountsReceivableId = quote.billToAddress?.accountsReceivableId;

  return {
    orderType: quote.orderType || OrderType.BILLABLE,
    billToLocation:
      billToAccountsReceivableId &&
      DEFAULT_BILL_TO_ADDRESS_ACCOUNTS_RECEIVABLE_ID !== billToAccountsReceivableId
        ? quote.billToAddress
        : null,
    shipToLocation: quote.shipToAddress || null,
    shipSelection: quote.shipSelection ?? ShipSelection.NO_DELIVERY_DATE,
    earliestAcceptableDate: getDefaultEarliestAcceptableDate(quote),
    requiredOnSiteDate: quote.requiredOnSiteDate ? dayjs(quote.requiredOnSiteDate) : null,
    shippingMethod: quote.shippingMethodId
      ? { id: quote.shippingMethodId, name: quote.shippingMethodName }
      : null,
    freightTerm: quote.freightTermId
      ? { id: quote.freightTermId, name: quote.freightTermName }
      : null,
  };
};
